module.exports = __webpack_public_path__ + "img/35_ancillary.05a9a9fd.jpg";